import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

import { AppContext } from "./appContext";

const MessagesContext = createContext();

function MessagesContextProvider({ children }) {
  const [message, setMessage] = useState(null);
  const [pages, setPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(null);
  const [isWorkspaceLoading, setIsWorkspaceLoading] = useState(false);

  const { jwt } = useContext(AppContext);

  const goBack = () => {
    setPages((prevPages) => [...prevPages].slice(0, prevPages.length - 1));
  };

  const replacePage = (newPage) => {
    setPages((prevPages) => [
      ...[...prevPages].slice(0, prevPages.length - 1),
      newPage,
    ]);
  };

  const displaySearchResult = (objId, objType) => {
    getSalesforceObject(objId, objType).then((newPage) => {
      // TODO: check if any error
      setPages([newPage]);
    });
  };

  const displayObject = (objId, objType) => {
    getSalesforceObject(objId, objType).then((newPage) => {
      // TODO: check if any error
      setPages((prevPages) => [...prevPages, newPage]);
    });
  };

  const getSalesforceObject = async (objId, objType) => {
    setIsWorkspaceLoading(true);
    try {
      const result = await axios({
        method: "get",
        url: "/salesforce/api/salesforce_object",
        params: {
          jwt: jwt,
          id: objId,
          type: objType,
        },
      });
      console.log("RESULT", "/salesforce/api/salesforce_object", result);
      setIsWorkspaceLoading(false);
      return result.data;
    } catch (error) {
      setIsWorkspaceLoading(false);
      console.log(error);
    }
  };

  const displayNewPluginForm = (pluginObjectId) => {
    console.log("DISPLAY NEW PLUGIN FORM", pluginObjectId);
    getPluginObject(pluginObjectId).then((newPage) => {
      // TODO: check if any error
      setPages((prevPages) => [...prevPages, newPage]);
    });
  };

  const getPluginObject = async (pluginObjectId) => {
    setIsWorkspaceLoading(true);
    try {
      const result = await axios({
        method: "get",
        url: `/salesforce/api/plugin_object/${pluginObjectId}`,
        params: {
          jwt: jwt,
        },
      });
      console.log("RESULT", result);
      setIsWorkspaceLoading(false);
      return result.data;
    } catch (error) {
      setIsWorkspaceLoading(false);
      console.log(error);
    }
  };

  const displaySalesforceNew = (objectType, parent) => {
    console.log("DISPLAY NEW SALESFORCE FORM", objectType);
    getNewSalesforceForm(objectType, parent).then((newPage) => {
      // TODO: check if any error
      setPages((prevPages) => [...prevPages, newPage]);
    });
  };

  const getNewSalesforceForm = async (objectType, parent) => {
    setIsWorkspaceLoading(true);
    try {
      const result = await axios({
        method: "get",
        url: "/salesforce/api/salesforce_object/new",
        params: {
          jwt: jwt,
          type: objectType,
        },
      });
      console.log("RESULT", result);
      setIsWorkspaceLoading(false);
      result.data.parent = parent;
      return result.data;
    } catch (error) {
      setIsWorkspaceLoading(false);
      console.log(error);
    }
  };

  const displaySalesforceEdit = (objectType, objectId) => {
    console.log("DISPLAY EDIT SALESFORCE FORM", objectType, objectId);
    getEditSalesforceForm(objectType, objectId).then((newPage) => {
      // TODO: check if any error
      setPages((prevPages) => [...prevPages, newPage]);
    });
  };

  const getEditSalesforceForm = async (objectType, objectId) => {
    setIsWorkspaceLoading(true);
    try {
      const result = await axios({
        method: "get",
        url: "/salesforce/api/salesforce_object/edit",
        params: {
          jwt: jwt,
          type: objectType,
          id: objectId,
        },
      });
      console.log("RESULT", result);
      setIsWorkspaceLoading(false);
      return result.data;
    } catch (error) {
      setIsWorkspaceLoading(false);
      console.log("Error getting the Salesforce form for editing", error);
    }
  };

  return (
    <MessagesContext.Provider
      value={{
        message,
        setMessage,
        pages,
        setPages,
        currentPage,
        goBack,
        replacePage,
        displaySalesforceNew,
        displaySalesforceEdit,
        displaySearchResult,
        displayObject,
        displayNewPluginForm,
        isWorkspaceLoading,
        setIsWorkspaceLoading,
      }}
    >
      {children}
    </MessagesContext.Provider>
  );
}

export { MessagesContextProvider, MessagesContext };
